(() => {
  const locale = document.documentElement.lang.toLowerCase().split('-')[0];
  const translations = {
    en: {
      right: 'Customise the right glove',
      left: 'Customise the left glove',
      remaining: 'characters remaining',
      preview: 'PREVIEW',
      field: 'Add a name or number to customise your TRJ product or create the perfect gift.',
      price: 'Customisation: fixed price of €7.50',
    },
    de: {
      right: 'Rechten Handschuh personalisieren',
      left: 'Linken Handschuh personalisieren',
      remaining: 'Zeichen verbleibend',
      preview: 'VORSCHAU',
      field: 'Füge einen Namen oder eine Nummer hinzu, um dein TRJ Produkt zu personalisieren oder das perfekte Geschenk zu gestalten.',
      price: 'Personalisierung: Festpreis 7,50 €',
    },
    fr: {
      right: 'Personnaliser le gant droit',
      left: 'Personnaliser le gant gauche',
      remaining: 'caractères restants',
      preview: 'APERÇU',
      field: 'Ajoutez un nom ou un numéro pour personnaliser votre produit TRJ ou créer le cadeau idéal.',
      price: 'Personnalisation : prix fixe de 7,50 €',
    },
    es: {
      right: 'Personaliza el guante derecho',
      left: 'Personaliza el guante izquierdo',
      remaining: 'caracteres restantes',
      preview: 'VISTA PREVIA',
      field: 'Añade un nombre o un número para personalizar tu producto TRJ o crear el regalo perfecto.',
      price: 'Personalización: coste fijo de 7,50 €',
    },
  };

  const copy = translations[locale];
  if (!copy) return;

  const replaceElementText = (selector, replacements) => {
    document.querySelectorAll(selector).forEach((element) => {
      const currentText = element.textContent.trim();
      const translatedText = replacements[currentText];

      if (translatedText && currentText !== translatedText) {
        element.textContent = translatedText;
      }
    });
  };

  const replaceLeadingText = (selector, sources, translatedText) => {
    document.querySelectorAll(selector).forEach((element) => {
      const textNode = Array.from(element.childNodes).find(
        (node) => node.nodeType === Node.TEXT_NODE && sources.some((source) => node.textContent.trim().includes(source)),
      );

      if (textNode && !textNode.textContent.includes(translatedText)) {
        textNode.textContent = `${translatedText} `;
      }
    });
  };

  const translatePersonalizer = () => {
    replaceElementText('.product-personalizer .pplr_tab_index span', {
      'Personalizza il Destro': copy.right,
      'Personalizza il Sinistro': copy.left,
    });

    replaceElementText('.product-personalizer .pplr-character-count .lt', {
      'characters left': copy.remaining,
    });

    replaceElementText('.product-personalizer .pplr-preview-btn', {
      PREVIEW: copy.preview,
    });

    replaceLeadingText(
      '.product-personalizer label.pplrlabel',
      ['Aggiungi nome o numero'],
      copy.field,
    );

    replaceLeadingText(
      '.product-personalizer .ptooltiptext',
      ['Personalizzazione costo fisso'],
      copy.price,
    );
  };

  let scheduled = false;
  const scheduleTranslation = () => {
    if (scheduled) return;

    scheduled = true;
    window.requestAnimationFrame(() => {
      scheduled = false;
      translatePersonalizer();
    });
  };

  scheduleTranslation();
  new MutationObserver(scheduleTranslation).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
